const sortByFlixbusCity = (a, b) => {
    if (a.isFlixbusCity && !b.isFlixbusCity) {
        return -1;
    } else if (b.isFlixbusCity && !a.isFlixbusCity) {
        return 1;
    }

    return 0;
};

export { sortByFlixbusCity };
